<template lang="html">
  <section id="PortabilityFAQs" class="padded">
    <h5>Preguntas frecuentes</h5>

    <h5>Aquí va una pregunta de la sección portabilidad.</h5>

    <p>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud in anim id est laborum adipisicing elit, sed do eiusmod tempor incididunt ut labore et.
    </p>

    <br />
    <h5>Aquí va una pregunta de la sección portabilidad.</h5>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud in anim id est laborum adipisicing elit, sed do eiusmod tempor incididunt ut labore et.
    </p>

    <br />
    <h5>Aquí va una pregunta de la sección portabilidad.</h5>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud in anim id est laborum adipisicing elit, sed do eiusmod tempor incididunt ut labore et.
    </p>

    <br />
    <h5>Aquí va una pregunta de la sección portabilidad.</h5>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud in anim id est laborum adipisicing elit, sed do eiusmod tempor incididunt ut labore et.
    </p>

    <br />
    <h5>Aquí va una pregunta de la sección portabilidad.</h5>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud in anim id est laborum adipisicing elit, sed do eiusmod tempor incididunt ut labore et.
    </p>

    <br />
    <h5>Aquí va una pregunta de la sección portabilidad.</h5>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud in anim id est laborum adipisicing elit, sed do eiusmod tempor incididunt ut labore et.
    </p>
  </section>
</template>

<script>
export default {
}
</script>
